export default "/build/images/mastercard.fdd172ae.png";